import React, { useEffect, useState, useContext, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import Images from 'assets/images/imageData';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import FormSection from 'components/sales/formSection/formSectionNew';
import TableSection from 'components/sales/tableSection/tableSection';
import DivLayout from 'components/sales/divLayout/divLayout';
import TextAreaInput from "../../../components/sales/Input/textAreaInput/textAreaInput";

const MaterialRequisition = ({
  getMrfDetails,
  mrfDetails,
  match,
  postApproval,
  postSendProcurement,
  location,
  getSiteInspect,
  siteData,
  history,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const Headers = ['Category', 'Qty by Ops', 'Qty by Sales	'];
  const [isModal, setIsModal] = useState(false);
  const [procurementSuccess, setProcurementSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [view, setView] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [remarks, setRemarks] = useState('');

  useEffect(() => {
    if (match.path.includes('view-material-requisition')) {
      (async () => {
        setView(true);
        await getSiteInspect(match.params.id, 1);
      })();
    } else setView(false);
  }, [match.path]);

  useEffect(() => {
    if (getMrfDetails !== null && match.params.id)
      (async () => {
        setIsLoading(true);
        await getMrfDetails(match.params.id);
        setIsLoading(false);
      })();
  }, [getMrfDetails, match.params.id]);

  const sendToApproval = async () => {
    const res = await postApproval(match.params.id, match.params.stageId);
    if (res) {
      setIsModal(true);
    }
  };

  const handleModalHide = () => setIsModal(false);
  const hideModal = () => setProcurementSuccess(false);

  const sendtoProcurement = async () => {
    setIsClicked(true);
    setIsLoading(true);
    const res = await postSendProcurement(
      match.params.id,
      match.params.stageId,
     remarks
    );
    setIsLoading(false);
    setIsClicked(false);
    if (res === true) {
      setProcurementSuccess(true);
    }
  };

  const editMrf = (gateId) => {
    history.push(`/dashboard/mrf-edit/${match.params.id}/${gateId}`);
  };

  return (
    <Layout
      title={localization.mrf}
      isGoback
      linkFlag={true}
      linkUrl={
        view
          ? `${baseUrl}/mrf-approvals`
          : `${baseUrl}/gate/site-inspection/${match.params.id}/stage/${match.params.stageId}`
      }
      isLoading={isLoading}
    >
      <div>
        <FormSection title={localization.materialAdded}>
          <div className="details-listing">
            {mrfDetails?.mrf?.mrf_id && (
              <Fragment>
                {' '}
                <DivLayout
                  heading={localization.mrfId}
                  data={
                    mrfDetails?.mrf?.mrf_id
                      ? mrfDetails?.mrf?.mrf_id
                      : localization.na
                  }
                />
                <hr />
              </Fragment>
            )}
            <TableSection
              data={mrfDetails && mrfDetails.categories}
              headers={Headers}
            ></TableSection>
          </div>
        </FormSection>

        {mrfDetails !== undefined &&
          mrfDetails.products &&
          mrfDetails.products.length > 0 &&
          mrfDetails.products.map((obj, index) => {
            return (
              <FormSection
                key={index}
                title={`${localization.productCategory} ${obj.category_name}`}
              >
                <table className="panel-table">
                  <thead>
                    <tr>
                      <th style={{'width':'50%'}}>{localization.productName}</th>
                      <th>{localization.productCode}</th>
                      <th>{localization.brand}</th>
                      <th>{localization.specification}</th>
                      <th>{localization.quantity}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {obj.materials.map((el) => {
                      return (
                        <tr>
                          <td>
                            <span className="th">
                              {localization.productName}
                            </span>
                            {el.material_name}
                          </td>
                          <td>
                            <span className="th">
                              {localization.productCode}
                            </span>
                            {el.material_code}
                          </td>
                          <td>
                            <span className="th">
                              {localization.brand}
                            </span>
                            {el.brand_name}
                          </td>
                          <td>
                            <span className="th">
                              {localization.specification}
                            </span>
                            {el.specification}
                          </td>
                          <td>
                            <span className="th">{localization.quantity}</span>
                            {el.quantity}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </FormSection>
            );
          })}

          <hr/>
          {/* <FormSection title='Tags' key="1">
          <table className="panel-table">
                  <thead>
                    <tr>
                      <th style={{'width':'50%'}}>{localization.name}</th>
                      <th>{localization.price}</th>
                      <th>{localization.quantity}</th>
                    </tr>
                  </thead>
          {mrfDetails !== undefined &&
          mrfDetails.tags &&
          mrfDetails.tags.length > 0 &&
          mrfDetails.tags.map((obj, index) => {
            return (
              
                  <tbody key={index}>
                   
                        <tr>
                        <td>
                          <span className="th">
                            {localization.tag_name}
                          </span>
                          {obj.tag_name}
                        </td>
                        <td>
                          <span className="th">
                            {localization.price}
                          </span>
                          {obj.price}
                        </td>
                        <td>
                          <span className="th">{localization.quantity}</span>
                          {obj.qty}
                        </td>
                      </tr>
                     
                    
                  </tbody>
               
            
            );
          })}
      </table>
            <div className="remark-text">
              <TextAreaInput
                  inputValue={remarks}
                  className="inline-css scrollbar-styling"
                  rows={4}
                  type="text"
                  label={localization.remarks}
                  required
                  handleChange={(e) => {setRemarks(e.target.value)}}
              />
            </div>
      </FormSection> */}
      <hr/>
        {location.state && location.state.view === false ? (
          <div className="btn-group d-md-inline-flex d-xs-col-flex mb-20">
            {/* <Button
              className="btn btn-transparent"
              onClick={() => {
                sendToApproval();
              }}
            >
              {localization.requestforApproval}
            </Button> */}
            <Button
              className="btn btn-primary"
              onClick={() => {
                sendtoProcurement();
              }}
              disabled={isClicked}
            >
              {localization.sendtoProcurement}
              <img src={Images?.ArrowRight} alt="" />
            </Button>
          </div>
        ) : null}
        {view && (
          <div>
            {siteData &&
              siteData?.gates?.length &&
              siteData?.gates?.map((obj, i) => {
                return (
                  mrfDetails?.mrf?.status !== 1 || (
                    <Button
                      className={`btn-transparent`}
                      onClick={() => {
                        editMrf(obj.gate_id);
                      }}
                    >
                      {`Edit MRF Details On Gate ${i + 1}`}
                    </Button>
                  )
                );
              })}
          </div>
        )}
      </div>
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.sentForApprovalSuccess}</h5>
          <Link
            to={`${baseUrl}/gate/site-inspection/${match.params.id}/stage/1`}
            className="btn btn-primary mb-4"
          >
            {localization.viewSiteInformation}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.conf}
        show={procurementSuccess}
        handleModalHide={hideModal}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.sentToProcurementSuccess}</h5>
          <Link
            to={`${baseUrl}/gate/site-inspection/${match.params.id}/stage/1`}
            className="btn btn-primary mb-4"
          >
            {localization.viewSiteInformation}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default MaterialRequisition;
